export default __webpack_public_path__ + "static/media/adorflower.8f47f9b8.ico";